import React from 'react'
import Layout from '../../components/layout/Layout'
import PinCodeTable from '../../elements/tables/pincodes/PinCodeTable'

export default function Pincode() {
  return (
    <div>
      <Layout>
        <PinCodeTable />
      </Layout>
    </div>
  )
}
